document.addEventListener("DOMContentLoaded", function () {

  // Fix CSS Shopify checkout
  document.querySelectorAll('link[rel="stylesheet"]').forEach(function(link) {
    if (link.href && link.href.includes('accelerated-checkout-backwards-compat')) {
      link.rel = 'preload';
      link.as = 'style';
      link.onload = function() {
        this.rel = 'stylesheet';
      };
    }
  });

  // Lazy loading images
  document.querySelectorAll('img').forEach(function(img) {

    if (
      img.closest('.hero') ||
      img.closest('.banner') ||
      img.classList.contains('no-lazy')
    ) {
      img.setAttribute('loading', 'eager');
      return;
    }

    img.setAttribute('loading', 'lazy');
  });

});
window.addEventListener('load', function() {
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-16755678863');
});